'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { ChevronsRight } from 'lucide-react';
import { Announcement } from '@/types/announcemants';
import IconAdaptive from '@/components/IconAdaptive';
import RectButton from '@/components/RectButton';
import SectionDecoratedTitle from '@/components/SectionDecoratedTitle';
import AnnouncementListUnit from '@/(routers)/announcements/list/components/unit/AnnouncementListUnit';

export interface TopAnnouncementsProps {
    announcements: Announcement[];
}

export default function TopAnnouncements({ announcements }: TopAnnouncementsProps) {
    const router = useRouter();
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const visibleAnnouncements = announcements.slice(0, isMobile ? 3 : 6);

    const goToAnnouncements = () => {
        router.push('/announcements');
    };

    return (
        <div className="flex flex-col justify-center items-center w-full pt-8 px-0 md:px-8">
            <div className="flex justify-center items-start w-full md:w-[98%] rounded-none md:rounded-3xl bg-color-white-base pt-8 px-8 pb-16">
                <div className="w-full md:w-[98%] lg:w-[85%] rounded-3xl">
                    <div className="flex w-full justify-start relative">
                        <div className="w-full pb-12">
                            <SectionDecoratedTitle title="ANNOUNCEMENT" subTitle="スクーミーからお知らせ" />
                        </div>
                        <div
                            className="absolute right-0 top-6 md:flex flex-grow justify-end items-center w-full font-notojp font-bold text-color-base text-sm lg:text-base cursor-pointer hidden md:block"
                            onClick={goToAnnouncements}
                        >
                            <IconAdaptive
                                Icon={ChevronsRight}
                                baseSize={22}
                                breakpoints={{ md: 24 }}
                                className="mt-[2px]"
                            />
                            もっとみる
                        </div>
                    </div>
                    {visibleAnnouncements.length > 0 && (
                        <>
                            <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-8 md:gap-4">
                                {visibleAnnouncements.map((announcement, i) => (
                                    <AnnouncementListUnit key={announcement.id} data={announcement} />
                                ))}
                            </div>
                            <div className="flex justify-center w-full py-8 md:hidden">
                                <RectButton label={'もっとみる'} width={'80%'} onClick={goToAnnouncements} />
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
